// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as IconCart$Showside from "../icons/IconCart.bs.js";
import * as IconButton$Showside from "./IconButton.bs.js";
import * as Transition$Showside from "../utils/Transition.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as CartAnimation$Showside from "./CartAnimation.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function SidePanel(Props) {
  var children = Props.children;
  var isOpen = Props.isOpen;
  var fwdRef = Props.fwdRef;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  var match$1 = ViewportContext$Showside.use(undefined);
  var isMobile = match$1.isMobile;
  var match$2 = EntrypointContext$Showside.use(undefined);
  var onCloseNavigation = match$2.onCloseNavigation;
  var onHomeClick = match$2.onHomeClick;
  var match$3 = CartContextProvider$Showside.useCart(undefined);
  var cart = match$3.cart;
  var isInlineNav = match$2.embedType === /* Inline */1;
  var onExit = React.useCallback(function (param) {
    Curry._1(onCloseNavigation, undefined);
  }, [onCloseNavigation]);
  var onHome = React.useCallback(function (param) {
    Curry._1(onHomeClick, undefined);
  }, [onHomeClick]);
  var match$4 = settings.panelSize;
  var openPosition = Cn.make([match$4 !== 2 && match$1.breakpoint >= 2 ? "translate-x-0 opacity-100" : "translate-x-0", "pointer-events-auto ease-out-cubic"]);
  var match$5 = settings.panelSize;
  var tmp;
  var exit = 0;
  if (match$5 !== 2 && !isMobile) {
    var match$6 = settings.panelPosition;
    tmp = match$6 ? "translate-x-16 opacity-0" : "-translate-x-16 opacity-0";
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var match$7 = settings.panelPosition;
    tmp = match$7 ? "translate-x-full" : "-translate-x-full";
  }
  var closePosition = Cn.make([tmp, "pointer-events-none ease-in-out-quint"]);
  var match$8 = settings.panelPosition;
  var buttonPositionClassName = match$8 ? "left-0 -ml-16" : "right-0 -mr-16";
  var minWidth;
  if (isMobile || isInlineNav) {
    minWidth = "0px";
  } else {
    var match$9 = settings.panelSize;
    minWidth = match$9 >= 3 ? "100%" : "540px";
  }
  var width;
  if (isMobile || isInlineNav) {
    width = "100%";
  } else {
    var match$10 = settings.panelSize;
    switch (match$10) {
      case /* Large */0:
        width = "90%";
        break;
      case /* Medium */1:
        width = "60%";
        break;
      case /* Small */2:
        width = minWidth;
        break;
      case /* FullWidth */3:
        width = "100%";
        break;
    }
  }
  var negWidth;
  if (isMobile || isInlineNav) {
    negWidth = "0%";
  } else {
    var match$11 = settings.panelSize;
    switch (match$11) {
      case /* Large */0:
        negWidth = "10%";
        break;
      case /* Medium */1:
        negWidth = "40%";
        break;
      case /* Small */2:
        negWidth = "" + String(match$1.windowSize.width - 540 | 0) + "px";
        break;
      case /* FullWidth */3:
        negWidth = "0%";
        break;
    }
  }
  var match$12 = settings.backdrop;
  var match$13 = settings.backdropBlur;
  var wrapperPointerClassName = isOpen ? match$12 || match$13 || isInlineNav ? "pointer-events-auto" : "pointer-events-none" : isInlineNav ? "pointer-events-auto" : "pointer-events-none";
  var wrapperClassName = CSS$Showside.prefix(Cn.make(["w-full h-full fixed top-0 left-0", wrapperPointerClassName]));
  var match$14 = settings.panelPosition;
  var panelPositionClassName = isInlineNav ? "relative" : match$14 ? "absolute top-0 right-0" : "absolute top-0 left-0";
  var panelShadowClassName = isInlineNav ? "" : "shadow-lg";
  var panelTransitionClassName = isInlineNav ? "" : "transition-all transform-gpu duration-150 " + (isOpen ? openPosition : closePosition);
  var panelClassName = CSS$Showside.prefix(Cn.make(["bg-main h-full flex flex-col w-full", panelTransitionClassName, panelPositionClassName, panelShadowClassName]));
  var panelContentPositionClassName = isInlineNav ? "" : "absolute inset-0";
  var panelContentClassName = CSS$Showside.prefix(Cn.make(["flex flex-col w-full h-full", panelContentPositionClassName, isOpen ? "" : "overflow-hidden"]));
  var backdropFilter = CSS$Showside.prefix(Cn.make(["absolute top-0 h-full", settings.backdropBlur ? "backdrop-blur-xs-clear" : "", settings.panelPosition === /* Left */0 ? "right-0" : "left-0"]));
  var renderButtons = function (param) {
    var renderCloseButton = function (param) {
      return React.createElement(IconButton$Showside.make, {
        onClick: onExit,
        dark: true,
        icon: React.createElement(Unicons$Showside.UilTimes.make, {
          size: /* Px */{
            _0: 22
          }
        }),
        title: "Close",
        className: CSS$Showside.prefix("relative")
      });
    };
    var renderCheckoutButton = function (param) {
      var href = settings.checkoutLink;
      if (href === undefined) {
        return null;
      }
      var tmp = {
        dark: !isMobile,
        icon: React.createElement(IconCart$Showside.make, {
          size: 20
        }),
        title: "Checkout"
      };
      var tmp$1 = StringUtils$Showside.fromInt(99, undefined, cart.itemCount);
      if (tmp$1 !== undefined) {
        tmp.badge = Caml_option.valFromOption(tmp$1);
      }
      return React.createElement(Link$Showside.make, {
        children: null,
        href: href,
        className: CSS$Showside.prefix("relative")
      }, React.createElement(IconButton$Showside.make, tmp), React.createElement(CartAnimation$Showside.make, {
        productDirection: settings.panelPosition === /* Left */0 ? /* Left */2 : /* Right */3,
        tooltipDirection: settings.panelPosition === /* Left */0 ? /* Left */2 : /* Right */3,
        addedLabel: settings.pdpAddToCartConfirmation,
        className: CSS$Showside.prefix("absolute w-full h-full"),
        enabled: !isMobile
      }));
    };
    var renderHomeButton = function (param) {
      return React.createElement(IconButton$Showside.make, {
        onClick: onHome,
        dark: true,
        icon: React.createElement(Unicons$Showside.UilEstate.make, {
          size: /* Px */{
            _0: 20
          }
        }),
        title: "Home",
        className: CSS$Showside.prefix("relative")
      });
    };
    var match = settings.panelSize;
    if (isInlineNav || match >= 3 || isMobile) {
      return null;
    } else {
      return React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["absolute top-0 mt-4 flex flex-col space-y-4", buttonPositionClassName, settings.panelPosition === /* Left */0 ? "right-0" : "left-0"]))
      }, renderCloseButton(undefined), renderCheckoutButton(undefined), renderHomeButton(undefined));
    }
  };
  var renderBackdrop = function (param) {
    var match = settings.backdrop;
    var match$1 = settings.backdropBlur;
    if (match) {
      if (isMobile) {
        return null;
      }
      if (isInlineNav) {
        return null;
      }
    } else {
      if (!match$1) {
        return null;
      }
      if (isMobile) {
        return null;
      }
      if (isInlineNav) {
        return null;
      }
    }
    return React.createElement("div", {
      onClick: onExit
    }, React.createElement(Transition$Showside.make, {
      show: isOpen,
      enter: CSS$Showside.prefix("transition-opacity duration-150 ease-in-out"),
      enterFrom: CSS$Showside.prefix("opacity-0"),
      enterTo: CSS$Showside.prefix("opacity-100"),
      leave: CSS$Showside.prefix("transition-opacity duration-150 ease-in-out"),
      leaveFrom: CSS$Showside.prefix("opacity-100"),
      leaveTo: CSS$Showside.prefix("opacity-0"),
      className: CSS$Showside.prefix("absolute inset-0"),
      style: {
        backgroundColor: settings.backdropColor
      }
    }), React.createElement(Transition$Showside.make, {
      show: isOpen,
      enter: CSS$Showside.prefix("transition-opacity duration-150 delay-300 ease-in-out"),
      enterFrom: CSS$Showside.prefix("opacity-0"),
      enterTo: CSS$Showside.prefix("opacity-100"),
      leave: CSS$Showside.prefix("transition-opacity duration-150 ease-in-out"),
      leaveFrom: CSS$Showside.prefix("opacity-100"),
      leaveTo: CSS$Showside.prefix("opacity-0"),
      className: backdropFilter,
      style: {
        width: negWidth
      }
    }));
  };
  var tmp$1 = {
    className: panelClassName,
    style: {
      minWidth: minWidth,
      width: width
    }
  };
  if (fwdRef !== undefined) {
    tmp$1.ref = Caml_option.valFromOption(fwdRef);
  }
  return React.createElement("div", {
    className: wrapperClassName,
    style: {
      zIndex: settings.zIndex
    }
  }, renderBackdrop(undefined), React.createElement("div", tmp$1, React.createElement("div", {
    className: panelContentClassName
  }, children, renderButtons(undefined))));
}
SidePanel.displayName = "SidePanel";
var make = React.memo(SidePanel);
export { make };
/* make Not a pure module */